module.exports = __webpack_public_path__ + "static/media/film.8e3a48da.svg";